module.exports = __webpack_public_path__ + "img/redRubin@2x.f131479.png";